import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import Cookies from "js-cookie";

// Helper: decode __l__type (remove 7 chars from both ends)
function decodeLType(string) {
  try {
    const withoutFirstSeven = string.substring(7);
    const decoded = withoutFirstSeven.substring(0, withoutFirstSeven.length - 7);
    return decoded;
  } catch {
    return "user"; // fallback
  }
}

// Initial state
const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  isAuthenticated: false,
};

// Async thunk: Login
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ loginData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/developer-tool/google_login`, loginData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);

// Async thunk: Refresh Token
export const refreshToken = createAsyncThunk(
  "auth/refreshToken",
  async (_, { rejectWithValue }) => {
    const refresh = Cookies.get("_d_rtoken");
    if (!refresh) return rejectWithValue("Refresh token missing");

    try {
      const response = await axiosInstance.post(`/developer-tool/token_refresh`, { refresh });

      // Set new tokens
      console.log(response)
      const access = response.data?.access;
      const newRefresh = response.data?.refresh;

      Cookies.set("_d_token", access, { expires: 30, secure: true, sameSite: "Strict" });
      Cookies.set("_d_rtoken", newRefresh, { expires: 3000, secure: true, sameSite: "Strict" });

      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        Cookies.remove("_d_token");
        Cookies.remove("_d_rtoken");
        window.location.href = `${window.location.origin}/new/login`;
      }
      return rejectWithValue(error.response?.data || "Token refresh failed");
    }
  }
);

// Slice definition
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      Cookies.remove("_d_token");
      Cookies.remove("_d_rtoken");
    },
  },
  extraReducers: (builder) => {
    builder
      // loginUser
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action?.payload?.data;
        state.token = action?.payload?.data?.access_token;
        state.isAuthenticated = true;

        const accessToken = action?.payload?.data?.access_token;
        const refreshToken = action?.payload?.data?.refresh_token;

        Cookies.set("_d_token", accessToken, { expires: 30, secure: true, sameSite: "Strict" });
        Cookies.set("_d_rtoken", refreshToken, { expires: 3000, secure: true, sameSite: "Strict" });
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message || "Login failed";
      })

      // refreshToken
      .addCase(refreshToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload?.access;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Token refresh failed";
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
